/**
 * @file paddle 教程 ipynb 的教程
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import {IProjectDetailProps} from '../../type';
import NotebookPreview from '../baidu-notebook-preview/pc';

const ProjectDetail: React.FC<IProjectDetailProps> = React.memo(props => {
    const content = props.content as any;
    const {loading} = props;

    return (
        <div><NotebookPreview ipynb={content} loading={loading} /></div>
    );
});

export default ProjectDetail;
